import Image from '@ingka/image';
import ProductIdentifier from '@ingka/product-identifier';
import Skeleton from '@ingka/skeleton';
import type { AssetArticle } from '@repo/types/asset';
import { Paragraph } from '@repo/ui/typography';

import { ArticleCardItem } from '@/components/article-table/article-card/article-card-item';
import { ArticleTitleDescription } from '@/components/article-title-description/article-title-description.component';

import { getArticleNo, getAssetArticleKey } from '@/utils/article.utils';
import { formatPrice } from '@/utils/translation.utils';

import sharedStyles from '@/components/article-table/styles.module.scss';
import styles from './styles.module.scss';

interface Props {
    item: AssetArticle;
}

export const ArticleCardProduct = ({ item }: Props) => {
    const unitPrice = formatPrice(item.unitPrice, item.currency);
    const totalPrice = formatPrice(item.totalPrice, item.currency);

    const itemImage = item.imageUrl;
    const itemName = item.name;
    const itemDescription = item.description;
    const itemId = item.itemId;
    const itemQuantity = item.quantity;
    const isReferenceItem = item.isReferenceItem;

    return (
        <>
            <div
                className={`${sharedStyles.article_table_row} ${styles.row_product}`}
                data-testid="article-card-product"
            >
                <div>
                    <Paragraph>{itemQuantity}</Paragraph>
                </div>
                <div>
                    {itemImage && <Image src={itemImage} alt="" />}
                    <ArticleTitleDescription
                        title={itemName}
                        description={itemDescription}
                        isReferenceItem={isReferenceItem}
                    />
                </div>
                <div>
                    {itemId ? (
                        item.type !== 'TEXTLINE' && <ProductIdentifier value={getArticleNo(itemId)} subtle />
                    ) : (
                        <Skeleton />
                    )}
                </div>
                <div>
                    <Paragraph>{unitPrice}</Paragraph>
                </div>
                <div>
                    <Paragraph>{totalPrice}</Paragraph>
                </div>
            </div>
            <div className={styles.article_card_product_children_container}>
                {item.childItems?.map((item) => (
                    <ArticleCardItem item={item} key={getAssetArticleKey(item)} isChildItem />
                ))}
            </div>
        </>
    );
};
